import { render } from "./AddFacture2.vue?vue&type=template&id=222d41b5&ts=true"
import script from "./AddFacture2.vue?vue&type=script&lang=ts"
export * from "./AddFacture2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__